import * as React from 'react';

export const TriangleWarning = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="74" height="67" viewBox="0 0 74 67" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M36.9834 25.5V33.3333M36.9834 49H37.0226M9.84795 64.6667H64.1189C70.149 64.6667 73.9178 58.1389 70.9027 52.9167L43.7673 5.91667C40.7522 0.694445 33.2146 0.694444 30.1995 5.91667L3.06408 52.9167C0.0490326 58.1389 3.81785 64.6667 9.84795 64.6667Z"
			stroke="#F08F08"
			strokeWidth="4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
